import { render, staticRenderFns } from "./cancellationPolicy.vue?vue&type=template&id=ed6451ec&"
import script from "./cancellationPolicy.vue?vue&type=script&lang=js&"
export * from "./cancellationPolicy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ed6451ec')) {
      api.createRecord('ed6451ec', component.options)
    } else {
      api.reload('ed6451ec', component.options)
    }
    module.hot.accept("./cancellationPolicy.vue?vue&type=template&id=ed6451ec&", function () {
      api.rerender('ed6451ec', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-8qFO9M8xZMEj8/JS/cancellationPolicy.vue"
export default component.exports